import Vue from 'vue'
import { store } from '../main'
import { IState } from '../store/state'
export const initStateData = (window as any).hiqApp_uno_initState

export const expandableBoxesHandler = () => {
  // Expandable boxes
  const setMode = (box: HTMLElement, mode: boolean, height: number) => {
    const content = box.querySelector('[data-type="content"]') as HTMLElement
    const trigger = box.querySelector('[data-type="trigger"]') as HTMLElement

    content.setAttribute('aria-hidden', String(!mode))
    trigger.setAttribute('aria-expanded', String(mode))
    content.setAttribute('style', `max-height:${mode ? height : 0}px`)
  }

  const expandableBoxClicking = (trigger: HTMLElement) => {
    const box = document.querySelector(
      `[data-id="${trigger.dataset.wrapper}"]`
    ) as HTMLElement
    const content = box.querySelector('[data-type="content"]') as HTMLElement
    const contentHeight = (content.querySelector(
      '[class$="__wrapper"]'
    ) as HTMLElement).offsetHeight
    let contentHidden = content.getAttribute('aria-hidden') === 'true'

    setMode(box, contentHidden, contentHeight)
  }

  document.addEventListener('click', (event: any) => {
    if (event.target.classList.contains('hiq-exhibition-expandable__trigger'))
      expandableBoxClicking(event.target)
  })
}

export const EventBus = new Vue()

export const updateWPEditButton = (to: any) => {
  const wpEditLink = document.querySelector(
    '#wp-admin-bar-edit > a'
  ) as HTMLLinkElement
  if (wpEditLink) {
    const url = wpEditLink.href
    const splittedUrl = url.split('?')
    const prms: any = {}
    splittedUrl[1].split('&').forEach((entry: string) => {
      const split = entry.split('=')
      prms[split[0]] = split[1]
    })
    const path: string = to.name
    const id = (store.state.pagesContent.find(
      (item: any) => item.path === path
    ) as any).id
    if (id) {
      prms.post = id
      const output = [
        splittedUrl[0],
        Object.keys(prms)
          .map(key => `${key}=${prms[key]}`)
          .join('&')
      ].join('?')
      wpEditLink.href = output
    }
  }
}

export const setActiveMenuItem = (to: any) => {
  store.dispatch({
    type: 'setActiveMenuItem',
    payload: {
      to
    }
  })
}
